import React, { useEffect, useState } from "react";
import { getEvents } from "../Service/Api";
import { Link } from 'react-router-dom'
import Slider from "react-slick";
import LazyLoad from "react-lazyload";
const RecentActivity = () => {
    const [data, setData] = useState([]);

    useEffect(() => {
        const getData = async () => {
            const datas = await getEvents();
            setData(datas);
        };
        getData();
    }, []);
    var settings = {
        autoplay: true,
        infinite: true,
        autoplaySpeed: 2000,
        speed: 1000,
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 0,
        arrows: false,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    };
    return (
        <>
            <div className="row">
                <div className="eventbg">
                    <Slider {...settings}>
                        {/* {data.length > 0 && data.map((item, index) => (
      <div className="item">
                         <div className="homeeventbox">
                              <div className="homeeventboximg">
                                <LazyLoad> <img src={`https://webapi.entab.info/api/image/${item.images}`} className="img-fluid" alt="St. Francis Xavier School"/> </LazyLoad>                                  
                              </div>
                              <div className="homeeventboxdesc">
                              <div className="homeeventboxbottom">
                                     <span>{item.date}</span> 
                                 </div>
                                 <div className="homeeventboxtitle"><p>{item.title} </p>
                                 <p>  <span>   <LazyLoad><img src="https://webapi.entab.info/api/image/SFXH/public/images/location.png" className="img-fluid" alt="St. Francis Xavier School"/></LazyLoad> {item.venue}</span></p>
                                 </div>                               
                              </div>
                          </div>
                    </div>
                     ))} */}
                        <div className="item">
                            <div className="recent_activity">
                                <img src="https://webapi.entab.info/api/image/SFXH/public/images/activity1.png" className="img-fluid" alt="St. Francis Xavier School" />
                                <p>Cooking without fire</p>
                                <p><span>24 Jan, 2025</span> </p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="recent_activity">
                                <img src="https://webapi.entab.info/api/image/SFXH/public/images/activity2.png" className="img-fluid" alt="St. Francis Xavier School" />
                                <p>Poster Making Events for Awareness of Vector Borne Disease</p>
                                <p><span>21 Jan, 2025</span> </p>
                            </div>
                        </div>

                        <div className="item">
                            <div className="recent_activity">
                                <img src="https://webapi.entab.info/api/image/SFXH/public/images/activity3.png" className="img-fluid" alt="St. Francis Xavier School" />
                                <p>Poster Making Events for Class II</p>
                                <p><span>16 Jan, 2025</span> </p>
                            </div>
                        </div>
                    </Slider>
                    {/* <button className="button">
        <Link to="/events">
        Read More</Link>
       </button> */}
                </div>
            </div>
        </>
    )
}

export default RecentActivity